import { create } from 'zustand';

interface FormValues {
  email: string;
}

type BlikFormState = {
  isFormValid: boolean;
  formValues: FormValues;
};

type BlikFormStateAction = {
  triggerFormValidation: () => void;
  setFormSubmit: (submitFunction: any) => void;
  setIsFormValid: (isValid: boolean) => void;
  setFormValues: (values: FormValues) => void;
};

export const useBlikForm = create<BlikFormState & BlikFormStateAction>()((set) => ({
  cardObj: null,
  isFormValid: false,
  formValues: { email: '' },
  triggerFormValidation: () => {},
  setFormSubmit: (submitFunction: any) => set({ triggerFormValidation: submitFunction }),
  setIsFormValid: (isFormValid: boolean) => set({ isFormValid }),
  setFormValues: (values: FormValues) => set({ formValues: values }),
}));
